import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import styled from '../../../components/Theme';
const FooterLinksListWrapper = styled(UIFlex).withConfig({
  displayName: "FooterLinks__FooterLinksListWrapper",
  componentId: "sc-1x3u9b1-0"
})(["gap:18px;@media (max-width:", "){flex-direction:column;gap:10px;}"], props => props.theme.sizes.GRID_BREAKPOINT_MEDIUM);
const FooterLinkWrapper = styled(UILink).withConfig({
  displayName: "FooterLinks__FooterLinkWrapper",
  componentId: "sc-1x3u9b1-1"
})(["color:", ";:hover{color:", ";}@media (max-width:", "){display:inline-block;}"], props => props.theme.colors.OLAF, props => props.theme.colors.OLAF, props => props.theme.sizes.GRID_BREAKPOINT_MEDIUM);

const FooterLink = ({
  domain,
  path = '',
  children
}) => {
  return /*#__PURE__*/_jsx(FooterLinkWrapper, {
    href: `${getFullUrl(domain)}/${path}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `app.footer.links.${children}`
    })
  });
};

const FooterLinks = () => {
  return /*#__PURE__*/_jsxs(FooterLinksListWrapper, {
    justify: "end",
    children: [/*#__PURE__*/_jsx(FooterLink, {
      domain: "community",
      children: "community"
    }), /*#__PURE__*/_jsx(FooterLink, {
      domain: "app",
      path: "academy",
      children: "academy"
    }), /*#__PURE__*/_jsx(FooterLink, {
      domain: "legal",
      path: "legal-stuff",
      children: "legal"
    }), /*#__PURE__*/_jsx(FooterLink, {
      domain: "legal",
      path: "privacy-policy",
      children: "privacy"
    })]
  });
};

export default FooterLinks;